import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../assets/assets"; 
export default function HeaderLogo() {
  return (
    <div className="header-logo d-inline-block align-top">
      <Link to="/" >
        <img className="img-fluid" src={Images.siteLogo} alt="Site Logo" />
      </Link>
    </div>
  );
}
